import { axiosInstance } from "@hopper-b2b/api";
import { createApi, fakeBaseQuery } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import { getFallbackExperimentResponse } from "../hooks/experimentDefaults";
import type { ExperimentResponse } from "../types";

export const handleAxiosError = (error: unknown) => {
  if (axios.isAxiosError(error)) {
    const status = error.response?.status ?? 500;
    const data = error.response?.data ?? error.message;
    return { type: "network", error: { status, data } };
  }

  return {
    error: { type: "unknown" },
  };
};

export const experimentsApi = createApi({
  reducerPath: "experimentsApi",
  baseQuery: fakeBaseQuery(),
  tagTypes: ["Experiments"],
  endpoints: (builder) => ({
    getExperiments: builder.query<ExperimentResponse, void>({
      queryFn: async () => {
        try {
          const res = await axiosInstance.put("/api/v0/experiments/active", {});

          return { data: res.data };
        } catch (error) {
          // Return fallback experiment data instead of failing
          // This ensures the app remains functional even if LaunchDarkly is down
          console.warn(
            "LaunchDarkly experiments failed, using fallback defaults:",
            error
          );
          return { data: getFallbackExperimentResponse() };
        }
      },
      providesTags: ["Experiments"],
    }),
  }),
});
